const SendingMessagesSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_5322_876)">
        <path
          d="M9.00195 4.50195H10.002C10.2672 4.50195 10.5215 4.60731 10.7091 4.79485C10.8966 4.98238 11.002 5.23674 11.002 5.50195V11.002L9.00195 9.00195H6.00195C5.73674 9.00195 5.48238 8.8966 5.29485 8.70906C5.10731 8.52152 5.00195 8.26717 5.00195 8.00195V7.50195M7.00195 4.50195C7.00195 4.76717 6.8966 5.02152 6.70906 5.20906C6.52152 5.3966 6.26717 5.50195 6.00195 5.50195H3.00195L1.00195 7.50195V2.00195C1.00195 1.73674 1.10731 1.48238 1.29485 1.29485C1.48238 1.10731 1.73674 1.00195 2.00195 1.00195H6.00195C6.26717 1.00195 6.52152 1.10731 6.70906 1.29485C6.8966 1.48238 7.00195 1.73674 7.00195 2.00195V4.50195Z"
          stroke="#333333"
          strokeWidth="0.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5322_876">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SendingMessagesSvg;
